import { render } from "./MobileIotProduct.vue?vue&type=template&id=3c19fd9b&scoped=true"
const script = {}

import "./MobileIotProduct.vue?vue&type=style&index=0&id=3c19fd9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c19fd9b"]])

export default __exports__